/**
 * Formate une date en chaîne de caractères selon le format français
 * @param date Date à formater ou chaîne ISO
 * @param includeTime Si true, inclut l'heure dans le résultat
 * @returns La date formatée en français
 */
export function formatDate(date: Date | string | null, includeTime = false): string {
  if (!date) return 'N/A';
  
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  
  if (isNaN(dateObj.getTime())) {
    return 'Date invalide';
  }
  
  const options: Intl.DateTimeFormatOptions = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    ...(includeTime && {
      hour: '2-digit',
      minute: '2-digit',
    }),
  };

  return new Intl.DateTimeFormat('fr-FR', options).format(dateObj);
}

/**
 * Calcule la différence en jours entre deux dates
 * @param startDate Date de début
 * @param endDate Date de fin (par défaut: maintenant)
 * @returns Le nombre de jours écoulés
 */
export function daysSince(startDate: Date | string, endDate: Date | string = new Date()): number {
  const start = typeof startDate === 'string' ? new Date(startDate) : startDate;
  const end = typeof endDate === 'string' ? new Date(endDate) : endDate;
  
  // Convertir en jours (1000ms * 60s * 60min * 24h)
  const diffTime = Math.abs(end.getTime() - start.getTime());
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
  
  return diffDays;
}

/**
 * Formate une durée en millisecondes en chaîne de caractères lisible
 * @param ms Durée en millisecondes
 * @returns Chaîne formatée (ex: "1,2 s" ou "350 ms")
 */
export function formatDuration(ms: number): string {
  if (ms >= 1000) {
    // Convertir en secondes avec une décimale
    return `${(ms / 1000).toFixed(1).replace('.', ',')} s`;
  } else {
    // Afficher en millisecondes
    return `${Math.round(ms)} ms`;
  }
}
